import { apiFetch } from './api';

type LineOauthLinkStart = { redirect_url: string };

/** `GET /line/link/me` のレスポンス型。ProfilePage・Home画面バナーの両方が同じキー(`['line-link-me']`)
 *  で参照するため、型もここに一本化する (2巡目実装レビューMinor反映、design-expert)。 */
export type LineLinkMe = { employee_id: string | null; linked: boolean; linked_at: string | null };

/**
 * v0.4 追加要件⑲改訂: LINE初回連携の開始 (LINE Login OAuth、D-845)。
 * `ProfilePage`・Home画面バナーの両方から使う共通処理。
 *
 * ⚠️ D-861 (2巡目レビュー反映、quality-assurance/security-reviewer Critical): このAPI呼び出しは
 * `credentials: 'include'` を明示すること。レスポンスの `Set-Cookie` (`line_oauth_expect`) は、
 * API(kpi-dashboard-api-*)とWeb(kpi-dashboard-4xa.pages.dev)が別オリジンのため、credentials指定が
 * 無いクロスオリジンfetchではブラウザに保存されない。省略すると、正当な利用者でもcallbackの
 * Cookie一致確認(D-861)が常に失敗し連携できなくなる。
 * 設計: docs/design/v04-line-account-linking-oauth-detail.md D-861
 */
export const startLineOauthLink = async (): Promise<void> => {
  const { redirect_url } = await apiFetch<LineOauthLinkStart>('/line/oauth/link/start', {
    method: 'POST',
    credentials: 'include',
  });
  window.location.href = redirect_url;
};
